/**
 * Class representing the lifecycle status of a Content Item with helper functions.
 */
export class ContentLifecycle {
    /**
     * Creates a new ContentLifecycle instance.
     * @param data JSON representation of the ContentLifecycle model
     */
    constructor(data) {
        if (data) {
            Object.assign(this, data);
        }
    }
    /**
     * Returns a boolean to indicate if the content should no longer be displayed by your application.
     * @param currentTime Optional date to override the current time.
     */
    isExpired(currentTime) {
        currentTime = currentTime || new Date();
        return (this.expiryTime !== undefined &&
            new Date(this.expiryTime).getTime() < currentTime.getTime());
    }
    /**
     * Export to JSON
     */
    toJSON() {
        return {
            expiryTime: this.expiryTime
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudExpZmVjeWNsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvY29udGVudC9tb2RlbC9Db250ZW50TGlmZWN5Y2xlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxPQUFPLGdCQUFnQjtJQVEzQjs7O09BR0c7SUFDSCxZQUFZLElBQVU7UUFDcEIsSUFBSSxJQUFJLEVBQUU7WUFDUixNQUFNLENBQUMsTUFBTSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsQ0FBQztTQUMzQjtJQUNILENBQUM7SUFFRDs7O09BR0c7SUFDSCxTQUFTLENBQUMsV0FBa0I7UUFDMUIsV0FBVyxHQUFHLFdBQVcsSUFBSSxJQUFJLElBQUksRUFBRSxDQUFDO1FBQ3hDLE9BQU8sQ0FDTCxJQUFJLENBQUMsVUFBVSxLQUFLLFNBQVM7WUFDN0IsSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxDQUFDLE9BQU8sRUFBRSxHQUFHLFdBQVcsQ0FBQyxPQUFPLEVBQUUsQ0FDNUQsQ0FBQztJQUNKLENBQUM7SUFFRDs7T0FFRztJQUNILE1BQU07UUFDSixPQUFPO1lBQ0wsVUFBVSxFQUFFLElBQUksQ0FBQyxVQUFVO1NBQzVCLENBQUM7SUFDSixDQUFDO0NBQ0YifQ==